module.exports = __webpack_public_path__ + "img/banner-complain.e3fa23b0.jpg";